export const container = `
  w-full h-full
  overflow-hidden
  bg-ll-surface
  font-sans
  rounded-md
  p-3
`;

export const header = `
  mb-2
`;

export const chartContent = `
  items-center
  h-[80%]
  overflow-hidden
  my-0 mx-auto
  w-[90%] max-w-[380px] 
  flex flex-row
  justify-between
`;

export const donutContainer = `
  w-[35%] md:w-[45%]
`;
